"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrandId = void 0;
/**
 * Gets the brand ID from various global sources depending on the module:
 * - MMB,Help and account uses window.__BRAND__?.id
 * - Booking/Search/Martech uses window.SP_GLOBALS.BRAND_ID or window.SP_GLOBALS.BRANDID
 *
 * @returns The brand ID string, defaulting to "kiwicom" if none found
 */
const getBrandId = () => {
  var _customWindow$__BRAND;
  if (typeof window === "undefined") {
    return "kiwicom";
  }
  const customWindow = window;

  // Check for __BRAND__ first (used in MMB, Help, and Account)
  if ((_customWindow$__BRAND = customWindow.__BRAND__) !== null && _customWindow$__BRAND !== void 0 && _customWindow$__BRAND.id) {
    return customWindow.__BRAND__.id;
  }

  // Check for SP_GLOBALS (used in Booking/Search/Martech)
  if (customWindow.SP_GLOBALS) {
    return customWindow.SP_GLOBALS.BRAND_ID || customWindow.SP_GLOBALS.BRANDID || "kiwicom";
  }
  return "kiwicom";
};
exports.getBrandId = getBrandId;